// A paid AI step runs at most this many times on the same input. The second
// attempt exists for a provider outage or a killed run, so it is spaced hours
// after the first rather than left to immediate platform retries.
export const AI_ATTEMPT_LIMIT = 2

export const AI_RETRY_MIN_AGE_MS = 6 * 60 * 60 * 1000

export function parseFailedAttemptCount(
  code: string | undefined
): number | undefined {
  if (code === undefined) {
    return undefined
  }
  const count = Number(code)
  return Number.isInteger(count) && count > 0 ? count : undefined
}

// Capped so the count stays a value `_tag:not` can select on.
export function nextFailedAttemptCount(previous: number | undefined): number {
  return Math.min((previous ?? 0) + 1, AI_ATTEMPT_LIMIT)
}

export function hasAttemptBudget(failedAttempts: number | undefined): boolean {
  return (failedAttempts ?? 0) < AI_ATTEMPT_LIMIT
}

export function isRetryDue(
  failedAt: string | undefined,
  now: number = Date.now()
): boolean {
  if (!failedAt) {
    return false
  }
  const failedAtMs = Date.parse(failedAt)
  return Number.isFinite(failedAtMs) && now - failedAtMs >= AI_RETRY_MIN_AGE_MS
}
